import useLocationOnMount from "seneca-common/utils/hooks/routing/useLocationOnMount";
import { logMessage } from "seneca-common/utils/sentry/logError";

import {
  linkToPasswordReset,
  linkToSignIn,
  linkToSignUp,
  linkToSignUpInvite,
  linkToSignUpParent
} from "features/sign-up/links";

import {
  getBackLocation,
  getBannerMessage,
  getRedirectAuthenticatedUserToLocation
} from "../links";
import { getBaseLink } from "../utils";

export default function useSignUpJourneyStateOnMount() {
  // We pull the details of the location state off on mount (e.g. backLocation/redirectAuthenticatedUserTo)
  // so we don't have to keep forwarding the state as we navigate between the pages in this journey
  const locationOnMount = useLocationOnMount();

  const baseLocation = getBaseLink(locationOnMount.pathname);

  const backLocation = (getBackLocation(locationOnMount) ||
    baseLocation) as string;

  const redirectAuthenticatedUserTo = (getRedirectAuthenticatedUserToLocation(
    locationOnMount
  ) || baseLocation) as string;

  if (isAnonymousRoute(redirectAuthenticatedUserTo)) {
    logMessage("Signed out route set as redirect location", {
      extraInfo: {
        baseLocation,
        redirectFromState:
          getRedirectAuthenticatedUserToLocation(locationOnMount)
      }
    });
  }

  const bannerMessage = getBannerMessage(locationOnMount);

  return {
    backLocation,
    redirectAuthenticatedUserTo,
    bannerMessage,
    search: locationOnMount.search
  };
}

function isAnonymousRoute(route: string) {
  return [
    linkToSignIn(),
    linkToSignUp(),
    linkToPasswordReset(),
    linkToSignUpInvite(),
    linkToSignUpParent()
  ].some(link => route === link);
}
